import { inject } from '@angular/core';
import { StatefulService } from '@app/service/stateful.service';
import { StatefulValue } from '@workflow/class/stateful-value.class';

export const coBorrowersPath = (protocol: string) => `${protocol}:coBorrowers`;

// tslint:disable: completed-docs
export class ApplicantStateful {
  private readonly statefulService = inject(StatefulService);

  public readonly borrowerId: StatefulValue;
  public readonly isCoBorrowerAJointApplication: StatefulValue;
  public readonly isCoApplicantHasJoint: StatefulValue;
  public readonly firstName: StatefulValue;
  public readonly lastName: StatefulValue;
  public readonly entityId: StatefulValue;
  public readonly parentId: StatefulValue;

  public static CoApplicant(protocol: string, iteration: number): ApplicantStateful {
    return new ApplicantStateful(protocol, iteration);
  }

  public static PrimaryApplicant(protocol: string): ApplicantStateful {
    return new ApplicantStateful(protocol, null, true);
  }

  constructor(public readonly protocol, public readonly iteration?: number, public readonly isPrimaryApplicant = false) {
    this.borrowerId = this.statefulService.wrap(this.apiPath('borrowerInfo/borrowerId'), null, iteration);
    this.isCoBorrowerAJointApplication = this.statefulService.wrap(
      this.apiPath('borrowerInfo/isCoBorrowerAJointApplication'),
      null,
      iteration
    );
    this.firstName = this.statefulService.wrap(this.apiPath('borrowerInfo/firstName'), null, iteration);
    this.lastName = this.statefulService.wrap(this.apiPath('borrowerInfo/lastName'), null, iteration);
    this.entityId = this.statefulService.wrap(this.apiPath('entityId'), null, iteration);
    this.parentId = this.statefulService.wrap(this.apiPath('parentId'), null, iteration);
    this.isCoApplicantHasJoint = this.statefulService.wrap(this.apiPath('borrowerInfo/isCoApplicantHasJoint'), null, iteration);
  }

  private apiPath(fieldName): string {
    const rootPath = this.isPrimaryApplicant ? `${this.protocol}:` : `${coBorrowersPath(this.protocol)}/#/`;
    return `${rootPath}${fieldName}`;
  }
}
